import type { SVGProps } from 'react';
const SvgThumbsDownSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.936 5c.961 0 1.741.788 1.741 1.759 0 .23-.047.447-.123.649.74.201 1.285.883 1.285 1.696 0 .334-.095.645-.254.913A1.754 1.754 0 0 1 22 11.743a1.76 1.76 0 0 1-1.049 1.612A1.76 1.76 0 0 1 22 14.968c0 .97-.78 1.759-1.742 1.759h-5.806l1.023 2.58c.09.23.138.48.138.729v.154c0 1-.802 1.81-1.793 1.81-.678 0-1.299-.388-1.604-1l-2.043-4.116a3.5 3.5 0 0 1-.367-1.572V8.474c0-.71.323-1.385.871-1.832l.443-.356A5.77 5.77 0 0 1 14.746 5zM6.903 7.345c.643 0 1.162.524 1.162 1.173v9.381c0 .649-.52 1.173-1.162 1.173H5.161A1.166 1.166 0 0 1 4 17.899V8.518c0-.649.519-1.173 1.161-1.173z"
    />
  </svg>
);
export default SvgThumbsDownSolid;
